import { useAuth } from "./auth.js";
import MaintenancePage from "./MaintenancePage.js";

export const PersonalShell = () => {
  const auth = useAuth();
  if (auth.user === null) return null;
  const authorized = auth.user.permissions.includes("personal:read");

  return (
    <div className="personal-shell">
      <header className="personal-topbar">
        <div>
          <span className="eyebrow">Area riservata</span>
          <strong>Area personale amministratore</strong>
        </div>
        <div className="personal-account">
          <span>{auth.user.displayName}</span>
          <button onClick={() => void auth.logout()}>Esci</button>
        </div>
      </header>
      <main className="personal-main">
        {authorized ? (
          <MaintenancePage />
        ) : (
          <section className="personal-access-denied">
            <h1>Accesso riservato</h1>
            <p>Usare le credenziali personali dedicate.</p>
            <button onClick={() => void auth.logout()}>Cambia account</button>
          </section>
        )}
      </main>
    </div>
  );
};
